import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {scrollToElement} from '@components/sticker/my-stickers/my-stickers-utils'
import {useBoard, useBoolean} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useMyStickersStore} from '../../my-stickers-store'
import {ListItem} from './list-item/list-item'

const TwLabels = tw.div<{$scrolled?: boolean}>`
  flex
  p-8
  text-xs-regular
  text-placeholder-new
  select-none
  ${p => cn(p.$scrolled && 'shadow-bottom-old z-10')}
`

const TwStickerList = tw(WithPerfectScrollbar)`
  flex
  flex-col
  flex-1
  -mr-16
  pr-16
`

const TwNotFound = tw.div`
  py-8
  pl-32
  text-sm-regular
  text-placeholder-new
`

export const List = observer(({highlight}: {highlight?: boolean}) => {
  const [state, store] = useMyStickersStore()
  const board = useBoard()
  const scrollTop = useBoolean(true)
  const itemList = useRef<Record<string, HTMLElement>>({})
  const selectedStickerId = state.selectedSticker?.id
  const listWrapper = useRef<HTMLElement>()

  useEffect(() => {
    if (listWrapper.current && selectedStickerId) {
      const itemRef = itemList.current[selectedStickerId]
      itemRef && scrollToElement(itemRef, listWrapper.current)
    }
  }, [selectedStickerId])

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <TwLabels $scrolled={!scrollTop.value}>
        <div className="w-1/3 pl-24">{Lang.msg.myStickers.name}</div>
        <div className="w-1/3 ml-24">
          {Lang.msg.myStickers.projectAndBoards}
        </div>
        <div className="w-1/3 ml-24">{Lang.msg.myStickers.action}</div>
      </TwLabels>
      <TwStickerList
        containerRef={ref => (listWrapper.current = ref)}
        onScrollY={x => scrollTop.setValue(x.scrollTop === 0)}
      >
        {store.filteredStickers.length === 0 ? (
          <TwNotFound>{Lang.msg.notFound}</TwNotFound>
        ) : (
          store.filteredStickers.map(stickerLibrary => (
            <ListItem
              key={stickerLibrary.sticker.id}
              ref={x => x && (itemList.current[stickerLibrary.sticker.id] = x)}
              stickerLibrary={stickerLibrary}
              highlight={highlight}
              board={board}
            />
          ))
        )}
      </TwStickerList>
    </div>
  )
})
